import { IStandardNavigationState, MenuItem } from "./standardNavigation.t";
import { MutationTypesStandardNavigation } from "./types";
import { ActionContext, ActionTree } from "vuex";
import { MutationsStandardNavigation, UpdateStandardNavigationPayload } from "./mutations";

type AugmentedActionContextStandardNavigation = {
    commit<K extends keyof MutationsStandardNavigation>(
        key: K,
        payload: Parameters<MutationsStandardNavigation[K]>[1]
    ): ReturnType<MutationsStandardNavigation[K]>
} & Omit<ActionContext<IStandardNavigationState, any>, 'commit'>

export interface MutationStandardNavigation {
    [MutationTypesStandardNavigation.UPDATE_STANDARD_NAVIGATION](
        { commit }: AugmentedActionContextStandardNavigation,
        payload: UpdateStandardNavigationPayload
    ): void
}

const actions: ActionTree<IStandardNavigationState, any> & MutationStandardNavigation = {
    [MutationTypesStandardNavigation.UPDATE_STANDARD_NAVIGATION]({ commit, state }, { activeComponent, activeSubComponent }) {
        const menu = state.menu;
        const isStandardMenuOpen = state.isStandardMenuOpen
        const isPreviousMenuStateOpen = state.isPreviousMenuStateOpen
        if (Array.isArray(menu)) {
            menu.map((item: MenuItem) => {
                item.active = item.id === activeComponent && activeSubComponent === '' ? true : false;
                if (item.children) {
                    item.children.map((child: MenuItem) => {
                        child.active = activeSubComponent !== '' ?
                         child.id === activeSubComponent ? true : false :
                         false;
                    })
                }
            });
            commit(MutationTypesStandardNavigation.UPDATE_STANDARD_NAVIGATION, { activeComponent, activeSubComponent, menu, isStandardMenuOpen, isPreviousMenuStateOpen });
        }
    },

    [MutationTypesStandardNavigation.UPDATE_MENU_STANDARD_NAVIGATION]({ commit, state }, payload) {
       commit(MutationTypesStandardNavigation.UPDATE_MENU_STANDARD_NAVIGATION, payload.menu);
    }
}
export default actions;